export default {"src":"/trader-new/_next/static/media/NTCFooterIcon.455d18e7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};